import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BellRinging } from "@phosphor-icons/react";
import api from "../lib/api";

const KIND_META = {
  missing_care_plan: { label: "Missing care plan", tone: "border-[#C0392B]/30 text-[#C0392B]" },
  careplan_review_due: { label: "Review due", tone: "border-[#C49A3A]/40 text-[#8a6a14]" },
  careplan_signature: { label: "Plan signature", tone: "border-[#C0392B]/30 text-[#C0392B]" },
  agreement: { label: "Agreement", tone: "border-[#C49A3A]/40 text-[#8a6a14]" },
  questionnaire_gaps: { label: "Questionnaire", tone: "border-stone-300 text-stone-600" },
  first_visit_face_to_face: { label: "First visit", tone: "border-stone-300 text-stone-600" },
  orientation_unsigned: { label: "Orientation", tone: "border-stone-300 text-stone-600" },
  intake_stalled: { label: "Intake", tone: "border-stone-300 text-stone-600" },
};

export function AttentionCard({ clientId = "", compact = false }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get(`/admin/attention${clientId ? `?client_id=${clientId}` : ""}`).then((r) => setData(r.data)).catch(() => {});
  }, [clientId]);
  if (!data) return null;
  const items = data.items || [];
  if (compact && items.length === 0) return null;
  return (
    <div className={compact ? "mb-4 rounded-xl border border-stone-200 bg-white p-4 shadow-sm" : "mb-6 rounded-xl border border-stone-200 bg-white p-5 shadow-sm"} data-testid={compact ? "client-attention" : "attention-card"}>
      <div className="flex items-center gap-2">
        <BellRinging size={18} className="text-[#C49A3A]" />
        <h2 className="font-heading text-lg font-semibold tracking-tight text-stone-900">Needs your attention</h2>
        <span className="rounded-full bg-stone-100 px-2 py-0.5 text-xs font-semibold text-stone-600" data-testid="attention-count">
          {items.length}{data.extra_observation_prompts ? ` +${data.extra_observation_prompts}` : ""}
        </span>
      </div>
      {items.length === 0 ? (
        <p className="mt-3 text-sm text-[#2F6B4F]" data-testid="attention-clear">All clear — nothing is waiting on you.</p>
      ) : (
        <div className="mt-3 space-y-1.5" data-testid="attention-list">
          {items.map((it, i) => {
            const meta = KIND_META[it.kind] || KIND_META.intake_stalled;
            return (
              <Link key={i} to={it.to}
                className="flex items-center justify-between gap-3 rounded-lg border border-stone-100 bg-stone-50/60 px-3 py-2 transition-colors hover:bg-stone-100"
                data-testid={`attention-item-${i}`}>
                <div className="flex min-w-0 items-center gap-2.5">
                  <span className={`shrink-0 rounded-full border px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${meta.tone}`}>{meta.label}</span>
                  <div className="min-w-0">
                    <p className="truncate text-sm font-semibold text-stone-800">{it.who}</p>
                    <p className="truncate text-xs text-stone-500">{it.what}</p>
                  </div>
                </div>
                {it.due && <span className="shrink-0 text-xs font-medium text-stone-400">{it.due}</span>}
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}
